import { render, staticRenderFns } from "./budget-distribution.vue?vue&type=template&id=5d2b509a&scoped=true&"
import script from "./budget-distribution.vue?vue&type=script&lang=ts&"
export * from "./budget-distribution.vue?vue&type=script&lang=ts&"
import style0 from "./budget-distribution.vue?vue&type=style&index=0&id=5d2b509a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b509a",
  null
  
)

export default component.exports